import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import ProfilesAPI from '../../../../utils/api/profilesAPI';

const entity = new ReduxRestEntity({
  name: 'profiles',
  primaryKey: 'key',
  api: ProfilesAPI(),
});

export default entity;
